import React from 'react';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import ic from '../images/ic.svg';
import { useState, useEffect } from "react";
import useDarkMode from 'use-dark-mode';
import { Tooltip, useTheme } from '@nextui-org/react';
import {FiSearch, FiLogOut} from 'react-icons/fi';
import {BiHomeAlt} from 'react-icons/bi';
import {TbSchool} from 'react-icons/tb';
import {FaRegUserCircle} from 'react-icons/fa';
import {SiGoogleclassroom} from 'react-icons/si';
import {CgPiano} from 'react-icons/cg';
import {ImCoinDollar} from 'react-icons/im';
import { BsMoon, BsSun} from 'react-icons/bs';

export default function SideBar(props){

    const [selected_li,setSelected_li] = useState(props.li);
    const darkMode = useDarkMode(false);
    const { type, isDark } = useTheme();
    
    useEffect(function mount() {
        
        if(props.title != null){

            document.title = props.title + " - پنل مدیریت";
        }else{

            document.title = $('#'+selected_li)[0].innerText + " - پنل مدیریت";
        }
        $('#'+selected_li).addClass('active');

        const body = document.querySelector("body");
        if (isDark){
            body.classList.add("dark");
        }else{
            body.classList.remove("dark");
        }
    });

    const darkModeClick = (e)=>{
        $("body").toggleClass('dark');
        darkMode.toggle();
    }

    const toggleClick = (e)=>{
        let isClose = localStorage.getItem('sidebarClose');
        localStorage.setItem('sidebarClose', isClose==='yes'?'':'yes')
        $(".sidebar").toggleClass('closee');
    }

    const collapse = (id)=>{
        $('#'+id).collapse('toggle');
        $('#collapseic').toggleClass('collapsed');

    }

    const handleLogout=()=>{
        localStorage.removeItem('admintoken');
        window.location.reload();
    }

    const handle_li=(e)=>{
        let id = e.currentTarget.id;
        let selectedid = selected_li;
        $('#'+selectedid).removeClass('active');
        setSelected_li(id);
        $('#'+id).addClass('active');
    }
    let isClose = localStorage.getItem('sidebarClose');

    return (
            <nav className={isClose==='yes'? 'sidebar closee':'sidebar'}>
                <header>
                    <div className='image-text'>
                        <span className='image'>
                            <img src={ic} alt='logo' />
                        </span>

                        <div className='text header-text'>
                            <span className='name'>آموزشگاه شمشال</span>
                            <span className='profession'>پنل مدیریت</span>
                        </div>
                    </div>

                    <i className='bx bx-chevron-left toggle' onClick={(e) => toggleClick(e)}></i>
                </header>
                <div className='menu-bar'>
                    <div className='menu'>
                        <li className="search-box">
                            
                            {/* <i className='bx bx-search icon'></i> */}
                            <FiSearch className='ic icon'/>
                            <input type="search" placeholder="جست و جو ..." />
                            
                        </li>
                        <ul className='menu-links'>
                            <li id="mainpanel" className="nav-link" onClick={handle_li.bind(this)}>
                            
                                <NavLink to="/">
                                    <Tooltip
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="داشبورد"
                                        placement="left"
                                    >
                                        <BiHomeAlt className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">داشبورد</span>
                                </NavLink>
                            
                            </li>
                            <li id="studentspanel" className="nav-link" onClick={handle_li.bind(this)}>
                                <NavLink to="/students">
                                    <Tooltip
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="هنرجویان"
                                        placement="left"
                                    >
                                        <TbSchool className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">هنرجویان</span>
                                </NavLink>
                            </li>
                            <li id="masterspanel" className="nav-link" onClick={handle_li.bind(this)}>
                                <NavLink to="/masters">
                                    <Tooltip
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="استادان"
                                        placement="left"
                                    >
                                        <FaRegUserCircle className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">استادان</span>
                                </NavLink>
                            </li>
                            <li id="instrumentspanel" className="nav-link" onClick={handle_li.bind(this)}>
                                <NavLink to="/instruments">
                                    <Tooltip
                                        css={{fontSize:'$3xl'}}
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="سازها"
                                        placement="left"
                                    >
                                        <CgPiano className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">سازها</span>
                                </NavLink>
                            </li>
                            <li id="classespanel" className="nav-link" onClick={handle_li.bind(this)}>
                                <NavLink to="/classes">
                                    <Tooltip
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="کلاس ها"
                                        placement="left"
                                    >
                                        <SiGoogleclassroom className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">کلاس ها</span>
                                </NavLink>
                            </li>
                            <li id="paymentspanel" className="nav-link" onClick={handle_li.bind(this)}>
                                <NavLink to="/payments">
                                    <Tooltip
                                        style={{height:'100%'}}
                                        color="secondary"
                                        content="پرداخت ها"
                                        placement="left"
                                    >
                                        <ImCoinDollar className='ic icon'/>
                                    </Tooltip>
                                    <span className="text nav-text">پرداخت ها</span>
                                </NavLink>
                            </li>
                            
                        </ul>
                    </div>

                    <div className="bottom-content">
                        <li className="logout" onClick={handleLogout.bind(this)}>
                            <a href="#">
                                <Tooltip
                                    style={{height:'100%'}}
                                        color="error"
                                        content="خروج"
                                        placement="left"
                                    >
                                    <FiLogOut className='ic icon'/>
                                </Tooltip>
                                <span className="text nav-text">خروج</span>
                            </a>
                        </li>

                        <li className="mode">
                            <div className="moon-sun">
                                <BsMoon className="ic icon moon"/>
                                <BsSun className="ic icon sun"/>
                                {/* <i className='bx bx-moon icon moon'></i>
                                <i className='bx bx-sun icon sun'></i> */}
                            </div>
                            <span className="mode-text text">حالت تاریک</span>
                            
                            
                                <div className="toggle-switch" onClick={(e) => darkModeClick(e)}>
                                    <Tooltip
                                        style={{height:'100%', alignItems:'center'}}
                                        color="secondary"
                                        content="حالت تاریک"
                                        placement="left"
                                    >
                                        <span className="switch"></span>
                                    </Tooltip>
                                </div>
                            
                        </li>               
                        
                    </div>
                </div>
            </nav>
            
            // <div className="col-12 col-md-2 bg-dark text-white px-0 collapse show scroll-style-md" id="sidebar">
            //     <div className="py-3 mr-2 text-right">منو اصلی</div>
            //     <ul className="nav flex-column pr-0 text-right">
            //         <li id="mainpanel" className="w-100 nav-item d-flex align-items-center my-1 pr-3" onClick={this.handle_li.bind(this)}>
            //             <span className="ti-dashboard"/>
            //             <NavLink to="/" className="nav-link w-100 h-100">داشبورد</NavLink>
            //         </li>

            //         <li id="pricespanel" className="w-100 nav-item">
            //             <div className="d-flex align-items-center">
            //                 <span className="ti-money pr-3"/>
            //                 <a className="nav-link my-1 w-100" data-toggle="collapse" role="button" onClick={(e) => this.collapse('pricespanel_menu')}>
            //                     کنترل قیمت
            //                     <span id="collapseic" className="oi oi-chevron-left float-left mr-2 collapsed"/>
            //                 </a>
            //             </div>
            //             <div className="collapse" id="pricespanel_menu">
            //                 <ul className="nav pr-0">
            //                     <li id="pricepanel" className="nav-item w-100 d-flex align-items-center my-1 pr-3" onClick={this.handle_li.bind(this)}>
            //                         <span className="ti-money pr-3"/>
            //                         <NavLink to="/price" className="nav-link w-100 h-100">قیمت و مالیات</NavLink>
            //                     </li>
            //                     <li id="offspanel" className="nav-item w-100 d-flex align-items-center my-1 pr-3" onClick={this.handle_li.bind(this)}>
            //                         <span className="ti-money pr-3"/>
            //                         <NavLink to="/offs" className="nav-link w-100 h-100">تخفیف ها</NavLink>
            //                     </li>

            //                 </ul>
            //             </div>
            //         </li>
            //         <li id="studentspanel" className="nav-item d-flex align-items-center w-100 my-1 pr-3" onClick={this.handle_li.bind(this)}>
            //             <span className="ti-user"/>
            //             <NavLink to="/students" className="nav-link w-100 h-100">هنرجویان</NavLink>
            //         </li>
            //         <li id="masterspanel" className="nav-item w-100 d-flex align-items-center my-1 pr-3" onClick={this.handle_li.bind(this)}>
            //             <span className="ti-user"/>
            //             <NavLink to="/masters" className="nav-link w-100">استادان</NavLink>
            //         </li>
            //         <li  id="instrumentspanel" className="w-100 nav-item d-flex align-items-center pr-3 my-1" onClick={this.handle_li.bind(this)}>
            //             <span className="ti ti-music-alt"/>
            //             <NavLink to="/instruments" className="nav-link w-100">ساز ها</NavLink>
            //         </li>
            //         <li  id="classespanel" className="w-100 nav-item d-flex align-items-center pr-3 my-1" onClick={this.handle_li.bind(this)}>
            //             <span className="ti ti-music"/>
            //             <NavLink to="/classes" className="nav-link w-100">کلاس ها</NavLink>
            //         </li>

            //         <li  id="paymentspanel" className="w-100 nav-item d-flex align-items-center pr-3 my-1" onClick={this.handle_li.bind(this)}>
            //             <span className="ti-list"/>
            //             <NavLink to="/payments" className="nav-link w-100">پرداخت ها</NavLink>
            //         </li>

            //     </ul>


            // </div>
    );
    
}
